import { Component, Input } from '@angular/core';
import { BILLING_STATUS } from '../../../enums';
import { CompanyData, SubscriptionDto } from '../../../interfaces';
import { CompanyService } from '../../../services/company.service';
import { addDays } from 'date-fns/addDays';

@Component({
  selector: 'app-subscription-stats',
  templateUrl: './subscription-stats.component.html',
  styleUrl: './subscription-stats.component.scss'
})
export class SubscriptionStatsComponent {
  protected readonly BILLING_STATUS = BILLING_STATUS;
  private readonly GRACE_PERIOD_DURATION_DAYS = 3;

  @Input({ required: true }) company!: CompanyData;
  @Input() currentSubscription: SubscriptionDto | null = null;

  getTrialStartDate() {
    return this.company.createdOn || null;
  }

  getGracePeriodEnd() {
    if (!this.company.billing?.nextPaymentDueAt) {
      return null
    }

    return addDays(new Date(this.company.billing.nextPaymentDueAt), this.GRACE_PERIOD_DURATION_DAYS)
  }

  getPriceWithDiscount(price: number) {
    const discount = this.company.billing?.discountPercentage ?? 0;
    return price - price * (discount / 100);
  }

  constructor(
    public readonly companyService: CompanyService
  ) {}
}
